import { SPACE_ELEMENTS_OF_MODAL } from "@components/common/dialog/dialog-constants";
import { UserDisplay } from "@components/common/user-display";
import { Dialog, Text } from "@flat-ui";
import { useSelfProjectAccess } from "@hooks/projects/use-self-project-access";
import { useRemoveMemberFromProject } from "@hooks/use-remove-member-from-project";
import { FaroCoreApiUtils } from "@stellar/core-api-client";
import { TableType } from "@utils/track-event/track-event-list";
/**
 * Asks to confirm removing a member from a project and removes them. Every place that removes
 * project members uses it, so that they all tell the same and behave the same.
 */
export function RemoveFromProjectDialog({
  companyId,
  project,
  member,
  location,
  onClose,
  onRemoved
}) {
  const {
    removeMember,
    isRemovingMember
  } = useRemoveMemberFromProject({
    companyId,
    project,
    trackingProps: {
      dataType: TableType.projectMembers,
      eventLocation: location,
      removeTarget: "project"
    },
    onRemoved
  });
  const {
    isLosingAccess
  } = useSelfProjectAccess({
    companyId,
    projectId: project.id
  });
  async function confirmRemove() {
    try {
      await removeMember(member);
    } finally {
      onClose();
    }
  }

  /** Tells what removing the member from the project means, which differs for the user themselves */
  function getDescription() {
    if (isLosingAccess({
      memberIdentity: member.identity,
      currentRole: member.role
    })) {
      return "You are removing yourself, so you may no longer be able to access this project. Only a project admin can invite you again.";
    }
    const entity = FaroCoreApiUtils.Member.isTeam(member) ? "team" : "member";
    return `When removing a ${entity} from the project they may no longer be able to access it. You can always invite this ${entity} again.`;
  }
  return <Dialog title="Remove from project" confirmText="Remove" open onConfirm={confirmRemove} onCancel={onClose} showSpinner={isRemovingMember} disabled={isRemovingMember}>
      <Text variant="bodyM" sx={{
      marginBottom: SPACE_ELEMENTS_OF_MODAL
    }}>
        {getDescription()}
      </Text>

      <UserDisplay member={member} />
    </Dialog>;
}